//libs
import { styled } from '@nykaa/ui-components';

// components
import ProductV2 from 'shared/components/ProductV2';

//GUTTER_SPACE represents the gap between the products
import { GUTTER_SPACE } from 'shared/components/ViewSimilar/Desktop/components/ViewSimilarOverlay/constants';

export const ProductsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing120} 0  ${theme.spacing.spacing120}`};
  justify-content: space-between;
`;

export const Product = styled(ProductV2)`
  width: calc(50% - ${GUTTER_SPACE}px);
  margin-bottom: ${({ theme }) => theme.spacing.spacing200};
`;
